// @noflow
import { ACCOUNT_ROUTES } from '@/routes'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import BowlIcon from 'assets/images/illustrations/bowls/bowl-with-food2.svg'
import PouchIcon from 'assets/images/illustrations/pouches/yellow-pouch.svg'
import VanIcon from 'assets/images/illustrations/vans/yellow-van.svg'

import { Button } from '@/components/elements/atoms/Button'
import Card from '@/components/elements/atoms/Card/Card'
import Text from '@/components/elements/atoms/Text/Text'
import STYLES from '@/components/pages/SegmentedPausedPage/SegmentedPausedPage.module.sass'

const EditPlan = ({
  identifier = 'segmented_paused_page.edit_your_plan_cta',
  disableBtn = false
}: {
  identifier?: string
  disableBtn?: boolean
}): JSX.Element => {
  const namespace = 'account'
  const { t } = useTranslation('account')
  const navigate = useNavigate()

  const navigateToEditPlan = useCallback((): void => {
    navigate(ACCOUNT_ROUTES.editPlan)
  }, [navigate])
  return (
    <Card border="none" padding={24} variant="brandYellow100">
      <div className={STYLES.summaryContent}>
        <Text
          namespace={namespace}
          text={`segmented_paused_page.coming_back_segment.tailor_your_plan.title`}
          variant="display20"
          margin={false}
        />
        <Text
          namespace={namespace}
          text={`segmented_paused_page.coming_back_segment.tailor_your_plan.subtitle`}
          margin={false}
          bold
        />

        <div className={STYLES.iconRows}>
          <div className={STYLES.iconRow}>
            <img
              alt={t(
                'segmented_paused_page.coming_back_segment.tailor_your_plan.alts.van'
              )}
              src={VanIcon}
              width={30}
              height={17.8}
            />
            <Text
              namespace={namespace}
              text={`segmented_paused_page.coming_back_segment.tailor_your_plan.delay`}
              margin={false}
            />
          </div>
          <div className={STYLES.iconRow}>
            <img
              alt={t(
                'segmented_paused_page.coming_back_segment.tailor_your_plan.alts.bowl'
              )}
              src={BowlIcon}
              width={30}
              height={20.5}
            />
            <Text
              namespace={namespace}
              text={`segmented_paused_page.coming_back_segment.tailor_your_plan.adjust`}
              margin={false}
            />
          </div>
          <div className={STYLES.iconRow}>
            <img
              alt={t(
                'segmented_paused_page.coming_back_segment.tailor_your_plan.alts.pouch'
              )}
              src={PouchIcon}
              width={30}
              height={20}
            />
            <Text
              namespace={namespace}
              text={`segmented_paused_page.coming_back_segment.tailor_your_plan.try`}
              margin={false}
            />
          </div>
        </div>
        <Button
          onClick={navigateToEditPlan}
          typography={{
            namespace,
            text: `segmented_paused_page.coming_back_segment.tailor_your_plan.cta`
          }}
          fullWidth
          identifier={identifier}
          variant="secondary"
          disabled={disableBtn}
        />
      </div>
    </Card>
  )
}

export default EditPlan
